import { Common } from '@thecvlb/design-system';
import classNames from 'classnames';

import { useZoomCall } from 'hooks';
import { useWidth } from 'hooks/useWidth';

import Participant from '../Participants/Participant';

import { ActiveParticipantProps } from './activeParticipant.types';

const ActiveParticipant: React.FC<ActiveParticipantProps> = ({
  activeSpeakers,
  connectionLost,
  interpreterRequested,
  participant,
  participantDisconnected
}) => {
  const { appointment, isMinimize, isOpenChat, languageRequested, toggleIsMinimize } =
    useZoomCall();

  const { isMobile } = useWidth();

  const isSpeaking = activeSpeakers?.some((speaker) => speaker.userId === participant?.userId);
  const isOpenChatOnMobile = isOpenChat && isMobile;
  const isMinimizeOrMobile = isMinimize || isOpenChatOnMobile;

  return (
    <div
      className={classNames('flex h-full items-center justify-center', {
        'max-md:border-[3px] max-md:border-red max-md:bg-red': isMinimizeOrMobile
      })}
    >
      {isMinimizeOrMobile && (
        <button className="h-full md:hidden" onTouchStart={toggleIsMinimize}>
          <Common.Icon className="text-white" name="arrow-left" />
        </button>
      )}
      <div
        className={classNames('relative size-full', {
          'overflow-hidden rounded-xl flex': isMinimizeOrMobile
        })}
      >
        {participant ? (
          <Participant key={participant.userId} {...participant} isMain isSpeaking={isSpeaking} />
        ) : languageRequested && interpreterRequested ? (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-5 bg-blue-100">
            {!isMinimizeOrMobile && (
              <Common.Icon name="chat" className="size-[60px] text-primary-600" />
            )}
            <h2
              className={classNames('text-center font-bold text-primary-600 px-9 text-xl', {
                '!px-px !text-xs': isOpenChatOnMobile
              })}
            >
              Interpreter requested
              <br />
              <span>
                ({languageRequested.label.toLowerCase().replace(/^./, (c) => c.toUpperCase())})
              </span>
            </h2>
          </div>
        ) : (
          <h2
            className={classNames(
              'video-call-bg absolute inset-0 flex items-center justify-center font-bold text-white px-9 text-xl',
              { '!px-px !text-xs': isOpenChatOnMobile }
            )}
          >
            {participantDisconnected ? (
              <>{appointment?.staffName || 'Provider'} left the call</>
            ) : (
              <>Waiting for {appointment?.staffName || 'provider'} to arrive...</>
            )}
          </h2>
        )}
        {connectionLost && (
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-gray-900 text-white">
            <Common.Icon
              className="mx-auto mb-2 size-[64px] animate-spin rounded-full bg-gray-800 p-4"
              name="loader"
            />
            <b>You lost your network connection</b>
            <p>Trying to reconnect...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActiveParticipant;
